import React from "react";
import styled, { css } from "styled-components";
import Loading from "../Loading";
import Contributor from "../common/Contributor";

class Contributors extends React.Component {
    state = {
        profiles: [],
        loading: false
    }

    componentDidMount() {
        const { country } = this.props;
        this.setState({ loading: true });

        if (this.props.country) {
            import(`../../data/profiles/${ country }.json`)
                .then(data => {
                    this.setState({
                        profiles: data.default,
                        loading: false
                    })
                })
                .catch(err => {
                    console.log(err);
                })
        }
    }

    componentWillUnmount() {
        this.props.history.push("/");
    }

    // Boilerplate => then styling
    render() {
        return <Container>
            <Loading isDisplayed={ this.state.loading } />
            { this.state.profiles.map((profile, index) => {
                return <Contributor 
                    profile={ profile }
                    mode={ this.props.mode }
                    key={ index }
                />
            }) }
        </Container>
    }
}

const Container = styled.div`
    overflow: auto;
    /* padding: 0 12px; */
    padding-right: 12px;
    height: calc(100vh - 200px);
    margin-top: 26px;

    &::-webkit-scrollbar-thumb {
        background: #565656;
        border-radius: 10px;
    }

    &::-webkit-scrollbar {
        background: #4040401c;
        width: 8px;
        border-radius: 10px;
    }
`

export default Contributors;